import { gql } from "../../../__generated__/gql";

export const EXPORT_FESTIVAL =
  gql(`query clashfinderExport($name: String!, $id:String!) {
  clashfinderExport(name: $name, id:$id)
}`);
